import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Report } from 'dashboard/models/report';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiModel, ApiResponse } from 'lib/interfaces/api';

export const reportApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    updateReportTags: builder.mutation<ApiResponse<Report>, { id: string; tags: string[] }>({
      query: ({ id, tags }) => {
        return SessionClientDashboard.postResourceAction<Report>(
          {
            type: ApiModel.Report,
            id,
          },
          'set-tags',
          { meta: { 'tag-id': tags } },
        );
      },
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const { useUpdateReportTagsMutation } = reportApi;
